<style scoped>

  #search-button {
    width: 120px;
  }

</style>

<template>

  <div :id="componentId" class="ui large modal customer-picker-modal">

    <div class="ui header">
      Selecionar Cliente
    </div>

    <div class="content modal-content-scrolling">

      <form class="ui form" @submit.prevent="onSearch()">
        <div class="fields">
          <div class="sixteen wide field">
            <div class="ui action input">
              <input type="text" placeholder="Código, CNPJ ou Razão Social" v-model="keyWord">
              <button id="search-button" type="button" class="ui basic button" :class="{ loading }" @click="onSearch()">
                <i v-if="!loading" class="search blue icon"></i> Pesquisar
              </button>
            </div>
          </div>
        </div>        
      </form>

      <div v-if="customers && customers.length == 0" class="ui small label m-t-15 animated fadeIn">
        <i class="info circle icon"></i> Nenhum cliente encontrado
      </div>

      <div v-if="customers && customers.length > 0" class="ui segment animated fadeIn" :class="{ loading }">        
        <table class="ui very basic celled selectable tablet stackable table">
          <thead class="desktop-only">
            <tr>        
              <th>Código</th>
              <th>Nome</th>
              <th>CNPJ/CPF</th>
              <th>Endereço</th>
            </tr>            
          </thead>
          <tbody>
            <tr v-for="customer in customers" :key="customer.code + customer.unit" class="clickable" 
              @click="onSelectCustomer(customer)">
              <td style="white-space: nowrap;">
                <strong class="mobile-only">Código: </strong>{{ customer.code + '-' + customer.unit }}
              </td>
              <td>
                <strong class="mobile-only">Nome: </strong>{{ customer.name }}
                <span v-if="customer.isProspect" class="ui small teal label m-l-10">Prospect</span> 
              </td>
              <td style="white-space: nowrap;">
                <strong class="mobile-only">CNPJ/CPF: </strong>{{ customer.formatCnpj }}
              </td>
              <td>
                <strong class="mobile-only">Endereço: </strong>{{ customerAddress(customer) }}
              </td>
            </tr>            
          </tbody>
        </table>
      </div>

    </div>

    <div class="actions">
      <button class="ui basic button" @click="onCancel()">
        <i class="reply icon"></i>
        Cancelar
      </button>      
    </div>

  </div>

</template>

<script>

  import CustomerService from "@/services/customer-service"
  import Message from "@/utils/message"
  
  export default {

    data() {
      return {
        componentId: "customer-picker",
        loading: false,
        keyWord: "",
        customers: null,
      }
    },

    props: ["id", "allowMultiple"],

    created() {

      if (this.id)
        this.componentId = this.id
    },

    mounted() {

      $("#" + this.componentId).modal({ allowMultiple: this.allowMultiple })
    },
    
    beforeDestroy() {
      $(".customer-picker-modal").remove()
    },

    methods: {

      show() {
        $("#" + this.componentId).modal("show")
      },

      hide() {
        $("#" + this.componentId).modal("hide")
      },

      async onSearch() {

        if (this.loading)
          return

        if (this.keyWord.trim().length < 4) {
          Message.info("Informe ao menos 4 caracteres para pesquisa")
          return
        }

        this.loading = true

        const keyWord = this.keyWord

        try {

          this.customers = await CustomerService.search({ keyWord })

          this.loading = false
          
        } catch (error) {
          
          this.loading = false
          this.$errorHandler(error)
        }
      },

      customerAddress(customer) {
        return CustomerService.customerAddress(customer)
      },

      onSelectCustomer(customer) {  

        if (customer.isBlocked) {
          Message.info("Esse cliente está bloqueado")
          return
        }
        
        $("#" + this.componentId).modal("hide")

        this.$emit("onSelect", customer)

        this.keyWord = ""
        this.customers = null
      },

      onCancel() {
        $("#" + this.componentId).modal("hide")
      },
    },
  }

</script>
